<template>
  <div>
    <b-section-loader
      :loading="$loading.isLoading(['fillPackageDirectory', 'nbuCreditTypes'])">
      <div v-if="debtorData?.status === 'Found'">
        <credit-version1
          v-show="crVersion === 'cr-version-1'"
          ref="pdfContentV1"
          :debtor-data="debtorData"></credit-version1>

        <credit-version2
          v-show="crVersion === 'cr-version-2'"
          ref="pdfContentV2"
          :debtor-data="debtorData"></credit-version2>
      </div>

      <div v-if="!debtorData?.status || debtorData?.status === 'NotFound'">
        <InfoNotFound></InfoNotFound>
      </div>
      <div v-if="debtorData?.status === 'LegallyWithheld'">
        Знайдена інформація не може бути надана у зв’язку із встановленими
        законодавством обмеженнями
      </div>
    </b-section-loader>
  </div>
</template>

<script lang="ts">
import { PropType, ref, watch } from 'vue'
import { BSectionLoader } from 'best-modules/components'
import { usePackageDirectory } from '@/store/package-directory'
import { DebtorData } from '@/utils/types/checkDebtor'
import { useDebtorResult } from './helpers'
import { fillDirectory } from '@/directory'
import InfoNotFound from '@/pages/check-debtor/components/InfoNotFound.vue'
import CreditVersion1 from '@/pages/check-debtor/single/tabs/credit-version-1.vue'
import CreditVersion2 from '@/pages/check-debtor/single/tabs/credit-version-2.vue'

export default {
  name: 'CheckDebtorResult',
  components: {
    CreditVersion2,
    CreditVersion1,
    InfoNotFound,
    BSectionLoader,
  },
  emits: ['update:pdfContent'],
  props: {
    debtorData: {
      type: Object as PropType<DebtorData>,
    },
    crVersion: {
      type: String,
    },
    pdfContent: {
      type: Object,
    },
  },
  setup(props, { emit }) {
    const pdfContentV1 = ref(null)
    const pdfContentV2 = ref(null)

    const { fillDirectory: fillPackageDirectory, directory } =
      usePackageDirectory()

    fillPackageDirectory()
    fillDirectory(['nbuCreditTypes', 'debtorCheckResult'])

    watch(
      () => props.crVersion,
      value => {
        if (value === 'cr-version-1' && pdfContentV1.value) {
          emit('update:pdfContent', pdfContentV1.value)
        }

        if (value === 'cr-version-2' && pdfContentV2.value) {
          emit('update:pdfContent', pdfContentV2.value)
        }
      }
    )

    watch(
      pdfContentV1,
      () => {
        emit('update:pdfContent', pdfContentV1.value)
      },
      { once: true }
    )

    return {
      pdfContentV1,
      pdfContentV2,
      directory,
      ...useDebtorResult(),
    }
  },
}
</script>

<style scoped lang="scss"></style>
